import { useEffect } from 'react';

import routes from '../common/constants/routes';
import localStorageService from '../common/services/localStorage/localStorage';
import { PageSpinner } from '../common/components/Spinner/Spinner';

/**
 * Převzetí přístupového tokenu z admin back-office (impersonate).
 * Token přichází v URL fragmentu (#token=...) — fragment se neposílá na server,
 * takže se neobjeví v access lozích. Uloží se do localStorage a appka se
 * restartuje na root, kde proběhne běžný auth flow.
 */
const Impersonate = (): JSX.Element => {
  useEffect(() => {
    const match = window.location.hash.match(/token=([a-zA-Z0-9]{64})/);

    if (!match) {
      window.location.replace(routes.login);
      return;
    }

    localStorageService.setToken(match[1]);
    // Poslední navštívená budova patřila původnímu uživateli — nesmí se přenést
    localStorageService.deleteLastBuildingId();
    window.location.replace(routes.root);
  }, []);

  return <PageSpinner />;
};

export default Impersonate;
